/* eslint-disable react-hooks/exhaustive-deps */
import { ContainerTableHome, TableViewHome } from "../../../components/Table";
import { getStakeTransactions } from "../../../services/app";
import { useApp } from "../../../contexts";
import {
  ContainerTableMobileHome,
  LabelTable,
  LabelTableViewAll,
} from "../styles";
import { useNavigate } from "react-router-dom";
import {
  DesktopContainer,
  MobileContainer,
} from "../../../components/Container";
import { ArrowRightIcon } from "../../../components/Icons/ArrowRightIcon";
import React, { useEffect, useMemo, useState } from "react";
import {
  RoundNumberOfDigitSGT,
  calculateInterestAmount,
  dateFormatNumber,
} from "../../../utils/helper";
import { EmptyTable2 } from "../../../components/EmptyTable";
import { WalletRowStake } from "../../wallet-list/components/WalletRowStake";
import { TextCellNormal } from "../../wallet-list/styles";
import NumberFormat from "react-number-format";
import {
  decimalSeparatorByCurrency,
  thousandSeparatorByCurrency,
} from "../../../utils/Currency";

const PAGE_SIZE = 5;

export const TableStake = () => {
  const {
    T,
    setLoading,
    convertToLocalCurrency,
    formatLocalCurrency,
    currency,
    getCurrency
  } = useApp();
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const columns = [
    {
      title: T("Stake Amount"),
      dataIndex: "amount",
      key: "amount",
      fixed: "left",
      align: "right",
      width: 150,
      render: (text, record, index) => (
        <TextCellNormal>
          {RoundNumberOfDigitSGT(record.amount)} {record.tokenName}
        </TextCellNormal>
      ),
    },
    {
      title: T("Duration"),
      dataIndex: "duration",
      key: "duration",
      align: "right",
      className: "",
      width: 150,
      render: (text, record, index) => (
        <TextCellNormal>
          <NumberFormat
            className="capitalize"
            value={record.duration}
            displayType="text"
            thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
            decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
            decimalScale={2}
            suffix={` ${record.duration > 1 ? T(record.durationUnit + 's') : T(record.durationUnit)}`}
          ></NumberFormat>
        </TextCellNormal>
      ),
    },
    {
      title: T("Interest rate"),
      dataIndex: "interestRate",
      key: "interestRate",
      align: "right",
      width: 150,
      render: (text, record, index) => (
        <TextCellNormal>
          <NumberFormat
            value={+text}
            displayType="text"
            thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
            decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
            decimalScale={0}
            suffix="%"
          ></NumberFormat>
        </TextCellNormal>
      ),
    },
    {
      title: T("Interest Amount"),
      dataIndex: "estReward",
      key: "estReward",
      align: "right",
      width: 200,
      render: (text, record, index) => (
        <TextCellNormal>
          <NumberFormat
            className="text-[#F12E11] font-[600]"
            value={calculateInterestAmount(
              record?.amount,
              record?.interestRate
            )}
            displayType="text"
            thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
            decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
            decimalScale={2}
            suffix=" SGT"
          ></NumberFormat>
        </TextCellNormal>
      ),
    },
    {
      title: T("Est. Converted Interest"),
      dataIndex: "valueInUsd",
      key: "valueInUsd",
      align: "right",
      width: 250,
      render: (text, record, index) => (
        <TextCellNormal>
          <span>
            {formatLocalCurrency(
              convertToLocalCurrency(
                calculateInterestAmount(
                  record?.amount,
                  record?.interestRate
                ),
                "USD",
                currency
              )
            )}
          </span>
        </TextCellNormal>
      ),
    },
    {
      title: T("Claim date"),
      dataIndex: "claimTime",
      key: "claimTime",
      align: "center",
      className: "",
      width: 200,
      render: (text, record, index) => (
        <TextCellNormal>{dateFormatNumber(text, "YYYY/MM/DD")}</TextCellNormal>
      ),
    },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      let result = await getStakeTransactions({
        pageSize: PAGE_SIZE,
      });
      if (result?.data) {
        const items = result?.data?.records;
        setRows(items);
      } else {
        setRows([]);
      }
    } catch (err) {
      setRows([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const viewRows = useMemo(() => {
    const data = [];
    if (rows.length > 0) {
      rows.map((row, i) => {
        if (i <= 4) data.push({ ...row });
        return null;
      });
    }
    return data;
  }, [rows]);

  const onClickViewAll = () => {
    navigate(`/stake-for-option`);
  };
  return (
    <div className="wallet-block">
      <div
        className="flex justify-between items-center
        px-[15px] py-[15px] lg:px-[40px] lg:py-[22px] xl:px-[40px] xls:px-[50px] xls:py-[27px] xls:h-[81px]
      "
      >
        <LabelTable className="flex gap-2">{T("Staking Balance")}</LabelTable>
        <LabelTableViewAll
          className="flex items-center gap-1 cursor-pointer"
          onClick={onClickViewAll}
        >
          {T("View all")}
          <ArrowRightIcon color="#818181" />
        </LabelTableViewAll>
      </div>
      <div className="wallet-block-items">
        <DesktopContainer>
          {rows?.length ? (
            <ContainerTableHome>
              <TableViewHome
                locale={{
                  emptyText: <EmptyTable2 T={T} />,
                }}
                scroll={{ x: true }}
                tableLayout={"fixed"}
                pagination={false}
                dataSource={viewRows}
                columns={columns}
              />
            </ContainerTableHome>
          ) : (
            <div className="flex justify-center">
              <EmptyTable2 T={T} />
            </div>
          )}
        </DesktopContainer>
        <MobileContainer>
          {rows.length ? (
            <ContainerTableMobileHome>
              {viewRows?.map((item, index) => (
                <WalletRowStake
                  className={"py-3"}
                  key={index}
                  viewType={1}
                  item={item}
                />
              ))}
            </ContainerTableMobileHome>
          ) : (
            <div className="flex justify-center">
              <EmptyTable2 T={T} />
            </div>
          )}
        </MobileContainer>
      </div>
    </div>
  );
};
